import { render } from "./ValidarPedidoCompraModal.vue?vue&type=template&id=4c558e23&scoped=true&ts=true"
import script from "./ValidarPedidoCompraModal.vue?vue&type=script&lang=ts"
export * from "./ValidarPedidoCompraModal.vue?vue&type=script&lang=ts"

import "./ValidarPedidoCompraModal.vue?vue&type=style&index=0&id=4c558e23&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c558e23"]])

export default __exports__